import { CreateHoldTypeCommand, HoldTypesApi, UpdateHoldTypeCommand } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class HoldTypeService {
  httpClient = createApiClient(HoldTypesApi)

  get = async (includeInActive?: boolean) => {
    const { data } = await this.httpClient.get(includeInActive)

    return data
  }

  getById = async (id: number) => {
    const { data } = await this.httpClient.getById(id)

    return data
  }

  create = async (cmd: CreateHoldTypeCommand) => {
    await this.httpClient.post(cmd)
  }

  update = async (cmd: UpdateHoldTypeCommand) => {
    await this.httpClient.put(cmd.id, cmd)
  }

  delete = async (id: number) => {
    await this.httpClient._delete(id)
  }
}

const holdTypeService = new HoldTypeService()

export default holdTypeService
